const FavoriteTypeTypes = {
    PROGRAM: "program",
    SEARCH: "search",
} as const;
export type FavoriteTypeTypes = typeof FavoriteTypeTypes[keyof typeof FavoriteTypeTypes];
export enum FavoriteTypeEnum {
    PROGRAM = "program",
    SEARCH = "search",
}